export default "__VITE_ASSET__dR0244aa__"